import { Box } from "@chakra-ui/react";

export default function AppFlatCardSpacer({ level }: { level: number }) {
  if (level > 1) {
    return <Box></Box>;
  }
  return null;
}
